(function () {
  class Freespins {
    constructor() {
      var self = this;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this._fsCountText = undefined;
      this._fsWinningsMeter = undefined;
      this._fsActive = false;
      this._freespinsCount = 0;
      this._spinsLeft = 0;
      this._outroPopup = undefined;
      this._outroPopupButton = undefined;
      this._winningsThisSpin = 0;
      this._landscapeMode = undefined;
      this._reelShiftAnimations = [];
      this._gameLoaded = false;
      this._skipOutroMove = false;

      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:FreeSpinsStartEvent', this.onFreespinsStart.bind(this));
      messageBus.subscribe('spinner:FreeSpinsStartEventDead', this.onFreespinsStartDead.bind(this));
      messageBus.subscribe('spinner:FreeSpinsDataEvent', this.onFreespinsData.bind(this));
      messageBus.subscribe('spinner:FreeSpinsDataEventDead', this.onFreespinsDataDeadEvent.bind(this));
      messageBus.subscribe('spinner:FreeSpinsRetriggerEvent', this.onFreespinsRetriggerEvent.bind(this));
      messageBus.subscribe('spinner:FreeSpinsEndEvent', this.onFreespinsEndEvent.bind(this));
      messageBus.subscribe('spinner:FreeSpinsEndEventDead', this.onFreespinsEndEventDead.bind(this));
      messageBus.subscribe('spinner:WinningLinesEvent', this.doPayWins.bind(this));
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);
      messageBus.subscribe('bountyhunter:skipWins', this.skipAnimations.bind(this));
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      messageBus.subscribe('spinner:FreeSpinsAwardEvent', this.onFreespinsAwarded.bind(this));
      messageBus.subscribe('spinner:FreeSpinsAwardEventDead', this.onFreespinsAwardedEnd.bind(this));
      messageBus.subscribe('spinner:GambleDataEvent', this.onGambleDataEvent.bind(this));
      messageBus.subscribe('spinner:GambleDataEventDead', this.onGambleDataEventEnd.bind(this));
      messageBus.subscribe('game:GambleResultEvent', this.onGambleResultEvent.bind(this));
      messageBus.subscribe('game:GambleResultEventDead', this.onGambleResultEventDead.bind(this));
      messageBus.subscribe('FreespinsExtraSpin', this.onFreespinsIncrement.bind(this));

      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });

      this.stateMachine.addState('IDLE', function () {});
      this.stateMachine.addState('OUTRO', function () {
        self.update_outroState();
      });
      this.stateMachine.addState('OUTRO_POPUP', function () {
        self.update_outroPopupState();
      });
    }

    update(delta, time) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    skipAnimations() {}

    /**
     *
     * why do we need this & onLayoutChange?
     */
    onOrientationChange() {
      if (!this._gameLoaded) {
        return;
      }

      this._skipOutroMove = true;

      if (
        layoutController.getCurrentLayout() === 'landscape_mobile' ||
        layoutController.getCurrentLayout() === 'landscape_default'
      ) {
        this._landscapeMode = true;
      } else {
        this._landscapeMode = false;
      }

      for (let i = 0; i < this._reelShiftAnimations.length; i++) {
        this._reelShiftAnimations[i].kill();
      }
      this._reelShiftAnimations = [];

      if (this._fsActive) {
        if (this._bg !== undefined) {
          this._bgLandscape.alpha = this._bg.alpha;
          this._bgPortrait.alpha = this._bg.alpha;
          this._bgLandscape.visible = this._bg.visible;
          this._bgPortrait.visible = this._bg.visible;
          switch (layoutController.getCurrentLayout()) {
            case 'landscape_default':
            case 'landscape_mobile': {
              this._bgPortrait.alpha = 1;
              this._bgPortrait.visible = false;
              this._bg = this._bgLandscape;
              this._landscapeMode = true;
              break;
            }
            case 'portrait_default':
            case 'portrait_mobile': {
              this._bgLandscape.alpha = 1;
              this._bgLandscape.visible = false;
              this._bg = this._bgPortrait;
              this._landscapeMode = false;
              break;
            }
          }
        }
        this.updateMeterText(true);
        this.updateButtonPositions(true);
        this.updateReelFramePosition(true);
      } else {
        this.updateMeterText(false);
        this.updateButtonPositions(false);
        this.updateReelFramePosition(false);
      }
    }

    onLayoutChange() {
      if (!this._gameLoaded) {
        return;
      }

      if (
        layoutController.getCurrentLayout() === 'landscape_mobile' ||
        layoutController.getCurrentLayout() === 'landscape_default'
      ) {
        this._landscapeMode = true;
      } else {
        this._landscapeMode = false;
      }

      // Update starting positions after layout has changed
      // This ensures we capture the correct base positions for the current orientation
      this.updateReelFrameAssetsStartingPositions();

      if (this._winlineTab) {
        if (gameController.inFreeSpins) {
          if (gameController.magicBet) {
            this._winlineTabMagicBet.visible = true;
            this._winlineTabMagicBetPortrait.visible = true;
          } else {
            this._winlineTab.visible = true;
            this._winlineTabPortrait.visible = true;
          }
        } else {
          this._winlineTab.visible = false;
          this._winlineTabPortrait.visible = false;
          this._winlineTabMagicBet.visible = false;
          this._winlineTabMagicBetPortrait.visible = false;
        }
      }
      if (this._fsActive) {
        //const fsCreditMeterPos = resourceManager.get('creditContainer_freespinsPosition').position;
        //this._baseCreditMeterContainer.position.set(fsCreditMeterPos.getX(), fsCreditMeterPos.getY());
        //const fsStakeMeterPos = resourceManager.get('betContainer_freespinsPosition').position;
        //this._baseStakeMeterContainer.position.set(fsStakeMeterPos.getX(), fsStakeMeterPos.getY());

        this.onOrientationChange();
      }
    }

    hideAllAnimations() {}

    update_outroPopupState() {
      if (this.phase.enter()) {
        this._fsActive = false;
        this._outroPopup.visible = true;
        this._outroPopup.alpha = 0;
        soundManager.stop('FreespinsMusic');
        soundManager.play('hbc_whoosh_v1');
      }

      if (this.phase.timed(500)) {
        this._popupMaskDimObject.show(true, this.phase.Progress);
        this._outroPopup.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._outroPopup.alpha = 1;
        this._outroPopupButton.interactive = true;
        const self = this;
        this._outroPopupButton.touchend = this._outroPopupButton.mouseup = function () {
          self.stateMachine.switchState('OUTRO');
          self._outroPopupButton.interactive = false;
          self._outroPopupButton.touchend = self._outroPopupButton.mouseup = function () {};
        };
      }
    }

    update_outroState() {
      if (this.phase.enter()) {
        this._popupMaskDimObject.show(false);
        this._outroPopup.alpha = 1;
        this._outroPopup.visible = false;
        gameData.winningsMeter.set(this._winnings);
        gameController.totalWinnings = this._winnings;
        this._fsActive = false;
      }

      if (this.phase.once()) {
        const fsCreditMeterPos = layoutController.getCurrentPosition('creditContainer');
        this._baseCreditMeterContainer.position.set(fsCreditMeterPos.x, fsCreditMeterPos.y);
        const fsStakeMeterPos = layoutController.getCurrentPosition('betContainer');
        this._baseStakeMeterContainer.position.set(fsStakeMeterPos.x, fsStakeMeterPos.y);

        this._bg.alpha = 1;
        this._bg.visible = false;

        resourceManager.getContainer('freespinsContainer').visible = false;
        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this._endHolder.leave();
        this._fsCountText.visible = false;
        resourceManager.getController('inputOverlord').setState('enabled');
        gameController.freespinsComplete(this._endHolder.data.totalWinnings);
      }
    }

    onGameConfigEvent() {
      this._gameLoaded = true;

      if (
        layoutController.getCurrentLayout() === 'landscape_mobile' ||
        layoutController.getCurrentLayout() === 'landscape_default'
      ) {
        this._landscapeMode = true;
      } else {
        this._landscapeMode = false;
      }

      this._gambleIntro = resourceManager.get('gambleIntroContainer:GambleIntro');
      this._gambleSpin = resourceManager.get('gambleSpinContainer:GambleSpin');
      this._freeSpinsIntroOutro = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro');
      this._wildPanel = resourceManager.get('freeSpinsWildPanel:freeSpinsWildPanelContainer');
      this._wildPanel.visible = false;

      this._baseFadeAssets = [
        resourceManager.getContainer('backgroundContainer'),
        resourceManager.get('preReels:reelBackersBase'),
        resourceManager.get('preReelsNudge:nudgeReelBackersBase'),
      ];

      this._fsFadeAssets = [
        resourceManager.getContainer('fsBackgroundContainer'),
        resourceManager.get('preReels:reelBackersFS'),
        resourceManager.get('preReelsNudge:nudgeReelBackersFS'),
      ];

      this._reelFrameAssets = [
        resourceManager.get('preReels'),
        resourceManager.get('preReelsNudge'),
        resourceManager.get('slotContainer'),
        resourceManager.get('nudgeSlotContainer'),
        resourceManager.get('postReels'),
        resourceManager.get('postReelsNudge'),
        resourceManager.get('symbolOverlayDisplay'),
      ];

      this.updateReelFrameAssetsStartingPositions();

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        this._fsFadeAssets[i].visible = false;
      }

      this.buttonCreditPanel = resourceManager.get('meterContainer:credit');
      this.buttonWinningsPanel = resourceManager.get('meterContainer:winnings');
      this.buttonStakePanel = resourceManager.get('meterContainer:stake');
      this.buttonFreeSpinPanel = resourceManager.get('meterContainer:freespins');
      this.buttonFreeSpinValue = resourceManager.get('meterContainer:freespins:value');
      this.buttonFreeSpinPanel.visible = false;

      this.updateMeterText(false);
      this.updateButtonPositions(false);
    }

    // Update the reel frame assets when we change Orientation
    // Previously these positions were only set once on game load
    updateReelFrameAssetsStartingPositions() {
      this._reelFrameAssetsStartingPositions = [
        {
          x: resourceManager.get('preReels').position.x,
          y: resourceManager.get('preReels').position.y,
        },
        {
          x: resourceManager.get('preReelsNudge').position.x,
          y: resourceManager.get('preReelsNudge').position.y,
        },
        {
          x: resourceManager.get('slotContainer').position.x,
          y: resourceManager.get('slotContainer').position.y,
        },
        {
          x: resourceManager.get('nudgeSlotContainer').position.x,
          y: resourceManager.get('nudgeSlotContainer').position.y,
        },
        {
          x: resourceManager.get('postReels').position.x,
          y: resourceManager.get('postReels').position.y,
        },
        {
          x: resourceManager.get('postReelsNudge').position.x,
          y: resourceManager.get('postReelsNudge').position.y,
        },
        {
          x: resourceManager.get('symbolOverlayDisplay').position.x,
          y: resourceManager.get('symbolOverlayDisplay').position.y,
        },
      ];
    }

    updateCountText() {
      if (this._fsActive && this._gameLoaded) {
        this.buttonFreeSpinValue.setTranslationParameters(this._freespinsCount - this._spinsLeft, this._freespinsCount);
      }
    }

    updateMeterText(inFreeSpins) {
      if (this.buttonCreditPanel && this._gameLoaded) {
        if (inFreeSpins) {
          this.buttonCreditPanel.position = resourceManager.get('meterContainer:creditPosFreeSpins').position;
          this.buttonWinningsPanel.position = resourceManager.get('meterContainer:winningsPosFreeSpins').position;
          this.buttonStakePanel.position = resourceManager.get('meterContainer:stakePosFreeSpins').position;
          this.buttonFreeSpinPanel.position = resourceManager.get('meterContainer:freeSpinsPosFreeSpins').position;
          this.buttonFreeSpinPanel.visible = true;
        } else {
          this.buttonCreditPanel.position = resourceManager.get('meterContainer:creditPosNormal').position;
          this.buttonWinningsPanel.position = resourceManager.get('meterContainer:winningsPosNormal').position;
          this.buttonStakePanel.position = resourceManager.get('meterContainer:stakePosNormal').position;
          this.buttonFreeSpinPanel.position = resourceManager.get('meterContainer:freeSpinsPosNormal').position;
          this.buttonFreeSpinPanel.visible = false;
        }
      }
    }

    updateButtonPositions(inFreeSpins) {
      if (!this._gameLoaded) {
        return;
      }

      if (inFreeSpins) {
        if (
          layoutController.getCurrentLayout() === 'landscape_mobile' ||
          layoutController.getCurrentLayout() === 'landscape_default'
        ) {
          resourceManager.get('buttonContainer:buttonBar:settingsMenu').visible = false;
          resourceManager.get('buttonContainer:buttonBar:stakeButton').visible = false;
          resourceManager.get('buttonContainer:buttonBar:autoplayButton').visible = false;
          if (layoutController.getCurrentLayout() === 'landscape_mobile') {
            resourceManager.get('buttonContainer:buttonBar:mute').position.setX(100);
            resourceManager.get('buttonContainer:buttonBar:mute').position.setY(650);
          } else {
            resourceManager.get('buttonContainer:buttonBar:mute').position.setX(125);
            resourceManager.get('buttonContainer:buttonBar:mute').position.setY(32);
          }
        } else if (
          layoutController.getCurrentLayout() === 'portrait_mobile' ||
          layoutController.getCurrentLayout() === 'portrait_default'
        ) {
          resourceManager.get('buttonContainer:buttonBar:settingsMenu').visible = false;
          resourceManager.get('buttonContainer:buttonBar:stakeButton').visible = false;
          resourceManager.get('buttonContainer:buttonBar:autoplayButton').visible = false;
          resourceManager.get('buttonContainer:buttonBar:mute').position.setX(50);
          resourceManager.get('buttonContainer:buttonBar:mute').position.setY(1170);
        }
      } else {
        if (
          layoutController.getCurrentLayout() === 'landscape_mobile' ||
          layoutController.getCurrentLayout() === 'landscape_default'
        ) {
          resourceManager.get('buttonContainer:buttonBar:settingsMenu').visible = true;
          resourceManager.get('buttonContainer:buttonBar:stakeButton').visible = true;
          resourceManager.get('buttonContainer:buttonBar:autoplayButton').visible = true;

          if (layoutController.getCurrentLayout() === 'landscape_mobile') {
            resourceManager.get('buttonContainer:buttonBar:mute').position.setX(1185);
            resourceManager.get('buttonContainer:buttonBar:mute').position.setY(220);
          } else {
            resourceManager.get('buttonContainer:buttonBar:mute').position.setX(125);
            resourceManager.get('buttonContainer:buttonBar:mute').position.setY(32);
          }
        } else if (
          layoutController.getCurrentLayout() === 'portrait_mobile' ||
          layoutController.getCurrentLayout() === 'portrait_default'
        ) {
          resourceManager.get('buttonContainer:buttonBar:settingsMenu').visible = true;
          resourceManager.get('buttonContainer:buttonBar:stakeButton').visible = true;
          resourceManager.get('buttonContainer:buttonBar:autoplayButton').visible = true;
          resourceManager.get('buttonContainer:buttonBar:mute').position.setX(190);
          resourceManager.get('buttonContainer:buttonBar:mute').position.setY(970);
        }
      }
    }

    updateReelFramePosition(inFreeSpins) {
      if (this._reelFrameAssets && this._gameLoaded) {
        for (let i = 0; i < this._reelFrameAssets.length; i++) {
          this._reelFrameAssets[i].position.x = this._reelFrameAssetsStartingPositions[i].x;
          this._reelFrameAssets[i].position.y = this._reelFrameAssetsStartingPositions[i].y;
        }

        if (inFreeSpins && this._landscapeMode) {
          for (let i = 0; i < this._reelFrameAssets.length; i++) {
            this._reelFrameAssets[i].position.x -= 50;
          }
        }
      }
    }

    doSpin() {
      this._winningsThisSpin = 0;
      this.updateCountText();
    }

    doSpinDead(spinTask) {}

    getNextSpinOutcome() {
      this.updateCountText();
      gameController.initNewSpin();
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsStart(task) {
      gameController.slotMachine.clearDimSymbolIds();

      resourceManager.getController('inputOverlord').setState('freespinsEnabled');
      messageBus.subscribe('spinner:SpinEvent', this._doSpinFunc);
      messageBus.subscribe('spinner:SpinEventDead', this._doSpinDeadFunc);
      messageBus.subscribe('spinner:WinningLinesEventDead', this._payWinsDeadFunc);

      gameController.slotMachine.selectReelMode('freespins');

      this._winnings = task.data.bonusWin + gameController.preFSReelPrize;
      this._freespinsCount = task.data.freeSpinsAwarded;
      //this._introFsCount.setTranslationParameters(this._freespinsCount);
      this._spinsLeft = task.data.freeSpinsAwarded - 1;
      //this._fsWinningsMeter.set(
      //  gameController.preFSReelPrize + task.data.bonusWin
      //);
      //this._fsCountText.setTranslationParameters(
      //  this._freespinsCount - this._spinsLeft,
      //  this._freespinsCount
      //);
      //this._fsCountText.visible = true;
      //this._introFsBonusWin.setTranslationParameters(
      //  gdk.formatCurrency(task.data.bonusWin)
      //);

      this._startHolder = task;
      this._startHolder.join();

      this._fsActive = true;

      // This is a bit of a hack to slightly delay FS intro screen
      // to tidy up animations. There are 3 entry points to FS
      const self = this;
      timerManager.addTimeout(500, function () {
        self.onDelayedFsStart(self._freespinsCount);
      });
    }

    onDelayedFsStart(freeSpinsCount) {
      this.updateCountText();
      this.updateMeterText(true);
      this.updateButtonPositions(true);

      const self = this;

      this._gambleIntro.doShowIntro(freeSpinsCount, function () {
        self.onFSIntroComplete();
      });
    }

    onFSIntroComplete() {
      const self = this;

      timerManager.addTimer(500, undefined, function () {
        self.freeSpinsTransitionIn();

        timerManager.addTimer(1500, undefined, function () {
          self._startHolder.leave();
          self._startHolder = undefined;
        });
      });
    }

    onFreespinsStartDead(task) {
      musicManager.onFreespinsStart();

      this.getNextSpinOutcome();
    }

    onFreespinsAwarded(task) {}

    onGambleDataEvent(task) {
      //autoplayManager.stopAutoplay();

      // let inRecovery = gameController.getIsRecovery();
      // if (!inRecovery) {
      //gdk.cancelAutoplay();
      this.freespinsAwardedTask = task;
      task.join();

      const self = this;

      timerManager.addTimer(1000, undefined, function () {
        self.prepareGamble(task);
      });
      //}
    }

    onGambleResultEvent(task) {
      let temp = task;
      temp.join();
      this._gambleSpin.spinToResult(task.data.won, function () {
        temp.leave();
        temp = undefined;
      });
    }

    onGambleResultEventDead(task) {
      if (!task.won) {
        musicManager.onFreespinsLostGambleEnd();
        let reels = resourceManager.get('slotContainer:reelContainer');
        reels.alpha = 1.0;

        musicManager.onFreespinsLostGambleEnd();
      }
    }

    prepareGamble(task) {
      if (!gdk.getPlatformAllowsGamble() || gameController.inBuyABonus) {
        this.onDecisionMade(task, task.data.resultCallback, 'collect');
        this.setupFsScene(task.data.numFreeSpins);
        resourceManager.getContainer('gambleIntroContainer').visible = true;

        let gambleBacker = resourceManager.get('gambleBacker');
        this._gambleIntro.fadeIn(gambleBacker, 0.8, 1.0, 0.0);

        gameController.fullScreenBubblesFront.startBubbles();
        timerManager.addTimeout(500, function () {
          gameController.fullScreenBubblesFront.stopBubbles();
        });
        gameData.topLayerMeters.visible = true;
        gameController.fullScreenBubblesBack.startBubbles();
        musicManager.onPlayBubbleIntro();
        //soundManager.play('bonusWon');

        return;
      }

      if (this._gambleSpin.visible) {
        this._gambleIntro.reactivate(
          task.data.numFreeSpins,
          task.data.nextFreespins,
          task.data.winChance,
          task.data.loseChance,
          this.onDecisionMade.bind(this, task, task.data.resultCallback)
        );
      } else {
        let initialDelay = 0;
        const self = this;
        timerManager.addTimer(initialDelay, undefined, function () {
          self._gambleIntro.start(
            task.data.numFreeSpins,
            task.data.nextFreespins,
            task.data.winChance,
            task.data.loseChance,
            function () {
              self.setupFsScene(task.data.numFreeSpins);
            },
            self.onDecisionMade.bind(this, task, task.data.resultCallback)
          );
        });
      }
    }

    freeSpinsTransitionIn() {
      for (let i = 0; i < this._baseFadeAssets.length; i++) {
        gsap.fromTo(
          this._baseFadeAssets[i],
          { visible: true, alpha: 1 },
          {
            alpha: 0,
            duration: 2,
          }
        );
      }

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        gsap.fromTo(
          this._fsFadeAssets[i],
          { visible: true, alpha: 0 },
          {
            alpha: 1,
            duration: 2,
          }
        );
      }

      this._wildPanel.scale.set(0);
      this._wildPanel.visible = true;
      gsap.to(this._wildPanel.scale, {
        duration: 2,
        delay: 0,
        x: 1,
        y: 1,
        ease: 'elastic.out(1,0.3)',
      });

      this._reelShiftAnimations = [];
      if (this._landscapeMode === true) {
        for (let i = 0; i < this._reelFrameAssets.length; i++) {
          let xPos = this._reelFrameAssetsStartingPositions[i].x - 50;

          const animation = gsap.to(this._reelFrameAssets[i], {
            duration: 2,
            x: xPos,
            ease: 'back.out(3)',
          });
          this._reelShiftAnimations.push(animation);
        }
      }
    }

    freeSpinsTransitionOut() {
      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        gsap.fromTo(
          this._fsFadeAssets[i],
          { visible: true, alpha: 1 },
          {
            alpha: 0,
            duration: 1,
          }
        );
      }

      for (let i = 0; i < this._baseFadeAssets.length; i++) {
        gsap.fromTo(
          this._baseFadeAssets[i],
          { visible: true, alpha: 0 },
          {
            alpha: 1,
            duration: 1,
          }
        );
      }

      gsap.to(this._wildPanel.scale, {
        duration: 1,
        delay: 0,
        x: 0,
        y: 0,
        ease: 'power1.inOut',
        onComplete: () => {
          this._wildPanel.visible = false;
          this._wildPanel.scale.set(1);
        },
      });

      this._reelShiftAnimations = [];
      if (this._landscapeMode === true && !this._skipOutroMove) {
        for (let i = 0; i < this._reelFrameAssets.length; i++) {
          let xPos = this._reelFrameAssetsStartingPositions[i].x;

          const animation = gsap.to(this._reelFrameAssets[i], {
            duration: 1,
            x: xPos,
            ease: 'power1.inOut',
          });
          this._reelShiftAnimations.push(animation);
        }
      }
    }

    setupFsScene() {
      musicManager.onFreespinsIntro();
      this._gambleIntro.showIntro();
    }

    hideReel() {
      let reels = resourceManager.get('slotContainer:reelContainer');

      var bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
      let animStrips = [];

      for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
        var animStrip = resourceManager.get(reelManager.reels[reelID].linkedAnimations[0].name);
        animStrips.push(animStrip);
      }

      timerManager.addTimer(
        300,
        function (progress) {
          animStrips.forEach((strip) => {
            strip.alpha = 1 - progress;
          });

          reels.alpha = 1.0 - progress;
        },
        function () {
          reels.alpha = 0;

          animStrips.forEach((strip) => {
            strip.hideAllAnimations();
          });

          for (var i = 0; i < reelManager.reels.length; i++) {
            for (var j = 0; j < 3; j++) {
              if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
                gameData.reels[i].showSymbol(j, true);
              }
            }
          }
        }
      );
    }

    onFreespinsAwardedEnd() {
      gdk.getNextGameOutcome(function () {});
    }

    onGambleDataEventEnd() {
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsData(task) {}

    onFreespinsDataDeadEvent(task) {
      this._spinsLeft--;

      this.startNextSpin();
    }

    startNextSpin() {
      if (this._winningsThisSpin > 0) {
        this.getNextSpinOutcome();
      } else {
        const self = this;
        timerManager.addTimer(450, undefined, function () {
          self.getNextSpinOutcome();
        });
      }
    }

    onFreespinsRetriggerEvent(task) {
      this._retriggerHolder = task;
      this._retriggerHolder.join();

      this._retriggerPopup.visible = true;
      this._retriggerPopup.alpha = 0;

      soundManager.play('hbc_whoosh_v1');
      const self = this;
      timerManager.addTimer(
        1000,
        function (progress) {
          self._popupMaskDimObject.show(true, progress);
          self._retriggerPopup.alpha = progress;
        },
        function () {
          self._retriggerPopup.alpha = 1;
          self._popupMaskDimObject.show(true, 1);

          self.displayRetriggerPanel();
        }
      );

      this._spinsLeft += task.data.num;
      this._freespinsCount += task.data.num;

      this.updateCountText();
    }

    onFreespinsIncrement() {
      this._spinsLeft++;
      this._freespinsCount++;
      this.updateCountText();
    }

    displayRetriggerPanel() {
      const self = this;

      timerManager.addTimeout(3000, function () {
        self.hideRetriggerPanel();
      });
    }

    hideRetriggerPanel() {
      const self = this;

      timerManager.addTimer(
        1000,
        function (progress) {
          self._popupMaskDimObject.show(true, 1 - progress);
          self._retriggerPopup.alpha = 1 - progress;
        },
        function () {
          self._retriggerPopup.alpha = 0;
          self._popupMaskDimObject.show(false, 1);

          self._retriggerHolder.leave();
        }
      );
    }

    doBigWinCheck() {
      let totalWinnings = this._endHolder.data.totalWinnings;
      let isCapped = this._endHolder.data.isCapped.isCapped;

      // Are we in a buy a bonus situation?
      // If so, don't trigger big win if the win is less than the buy a bonus cost
      // Basically 70 * base stake
      const inBuyABonus = gameController.inBuyABonus;
      const buyABonusBigWinStartLevel = gameController.globalHelperGetStake() * 70;

      if (inBuyABonus && totalWinnings < buyABonusBigWinStartLevel) {
        this.endFreespins();
        return;
      }

      let isBigWin = resourceManager.get('bigWin').willTriggerBigWin(totalWinnings);
      this._fsActive = false;

      if (isBigWin) {
        resourceManager.get('bigWin').start(
          totalWinnings,
          () => {
            this.endFreespins();
          },
          isCapped
        );
      } else {
        this.endFreespins();
      }
    }

    onFreespinsEndEvent(task) {
      const self = this;

      this._endHolder = task;
      this._endHolder.join();

      this._fsActive = false;
      this._skipOutroMove = false;

      messageBus.unsubscribe('spinner:SpinEvent', this._doSpinFunc);
      messageBus.unsubscribe('spinner:WinningLinesEventDead', this._payWinsDeadFunc);
      messageBus.unsubscribe('spinner:SpinEventDead', this._doSpinDeadFunc);

      gameController.slotMachine.selectReelMode('default');
      gameController.slotMachine.setInjectorMode('main');

      musicManager.wasInFreeSpins = true;
      musicManager.onFreespinsEnd();

      this._outroPopup = this._outroPopupWin;
      this._outroPopupButton = this._outroPopupWinButton;

      this.updateMeterText(false);
      this.updateButtonPositions(false);

      gameData.winningsMeter.set(task.data.totalWinnings);
      gameController.totalWinnings = task.data.totalWinnings;

      timerManager.addTimeout(2000, function () {
        self.freeSpinsTransitionOut();
      });

      gameController.fsWinnings = task.data.totalWinnings;

      this._freeSpinsIntroOutro.showOutro(task.data.fsWinnings, function () {
        self.doBigWinCheck();
      });
    }

    endFreespins() {
      this._endHolder.leave();
      this._endHolder = undefined;
    }

    onFreespinsEndEventDead(task) {
      gameData.mainTunePlaying = true;
    }

    doPayWins(task) {
      this._winningsThisSpin = task.data.totalLineWinnings;
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings;
      //this._fsWinningsMeter.set(this._winnings);
    }

    onDecisionMade(task, resultCallback, gambleDecision) {
      if (gambleDecision === 'collect') {
        resultCallback({ response: 'collect' }, function () {
          task.leave();
        });
      } else {
        resultCallback({ response: 'gamble' }, function () {
          task.leave();
        });
      }

      gameController.cancelAutoplay();
    }
  }

  new Freespins();
})();
